import React from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Button} from 'components';
import CollagePayrollIllustration from 'img/payroll/collage_payroll_illustration_simple@2x.png';

const PayrollInfo = observer(({uiState}) => {
  return (
    <div className='flex flex-col align-items-middle justify-content-between mt4'>
      <img className='mb2' style={{width: 500, maxWidth: '100%'}} src={CollagePayrollIllustration} alt='collage_payroll'/>
      <div className='h2 mb2'><FormattedMessage id='payroll.not_enabled.Run Payroll Directly In Collage'/></div>
      <ul className='IconList IconList--checkmark px1 mb3' style={{width: 500, maxWidth: '100%'}}>
        <li className='mb1'><FormattedMessage id='payroll.not_enabled.Pay your employees in Collage and stop juggling multiple systems'/></li>
        <li className='mb1'><FormattedMessage id='payroll.not_enabled.Avoid double entry by having onboarding, timesheets, and vacation pay integrated with payroll'/></li>
        <li className='mb1'><FormattedMessage id='payroll.not_enabled.Access pay stubs and T4s directly in Collage'/></li>
      </ul>
      <Button onClick={() => uiState.submit('payroll_sync') }>
        <FormattedMessage id="payroll.not_enabled.Learn More"/>
      </Button>
    </div>
  );
});

export default PayrollInfo;
